module.exports = "././img/footer.png";


//////////////////
// WEBPACK FOOTER
// ../assets/report-img/wa/footer.png
// module id = 827
// module chunks = 0